import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/homes/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/product',
    name: 'product',
    component: () => import(/* webpackChunkName: "product" */ '../views/product/index.vue')
  },
  {
    path: '/cats',
    name: 'cats',
    component: () => import(/* webpackChunkName: "cats" */ '../views/cats/index.vue')
  },
  {
    path: '/shopping',
    name: 'shopping',
    component: () => import(/* webpackChunkName: "shopping" */ '../views/shopping/index.vue')
  },
  {
    path: '/checkout',
    name: 'checkout',
    component: () => import(/* webpackChunkName: "checkout" */ '../views/checkout/index.vue')
  },

  {
    path: '/foot/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/foot/about.vue')
  },
  {
    path: '/foot/contact',
    name: 'contact',
    component: () => import(/* webpackChunkName: "contact" */ '../views/foot/contact.vue')
  },
  {
    path: '/foot/refundPolicy',
    name: 'refundPolicy',
    component: () => import(/* webpackChunkName: "refundPolicy" */ '../views/foot/refundPolicy.vue')
  },
  {
    path: '/foot/privacyPolicy',
    name: 'privacyPolicy',
    component: () => import(/* webpackChunkName: "privacyPolicy" */ '../views/foot/privacyPolicy.vue')
  },
  {
    path: '/foot/termsofUse',
    name: 'termsofUse',
    component: () => import(/* webpackChunkName: "termsofUse" */ '../views/foot/termsofUse.vue')
  },
]

const routerRePush = VueRouter.prototype.push
VueRouter.prototype.push = function (location) {
  return routerRePush.call(this, location).catch(error => error)
}

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
